import ReactStars from 'react-rating-stars-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/fontawesome-free-solid';
import './ratingStars.css';

function RatingStars(props) {
  const { edit, newValue } = props;
  const ratingChanged = (e) => {
    console.log(e);
  };
  return (
    <div className="ratingStars">
      <ReactStars
        count={5}
        onChange={(e) => ratingChanged(e)}
        isHalf
        value={newValue}
        edit={edit}
        emptyIcon={<FontAwesomeIcon icon={faStar} />}
        halfIcon={<FontAwesomeIcon icon={faStar} />}
        filledIcon={<FontAwesomeIcon icon={faStar} />}
        activeColor="#F5D730"
        color="#CCCCCC"
      />
    </div>
  );
}

export default RatingStars;
